<template>
  <ul class="my-menu-list">
    <li v-if="isLogin" class="item-container">
      <a
        class="item-wrapper"
        href="#"
        @click.prevent="goUrl({ path: '/my', name: 'my' })"
      >
        <w-profile-menu-item type="my" />
      </a>
    </li>
    <li v-if="!isLogin" class="item-container">
      <a class="item-wrapper" href="#" @click.prevent="onClickLogin">
        <w-profile-menu-item type="login" />
      </a>
    </li>
    <li v-if="isLogin" class="item-container">
      <button type="button" class="item-wrapper" @click.prevent="onClickAlarm">
        <w-profile-menu-item type="alarm" :count="alarmCount" />
      </button>
    </li>
    <li class="item-container">
      <router-link to="/voucher/index.html">
        <w-profile-menu-item type="ticket" :count="voucherCount" />
      </router-link>
    </li>
    <li class="item-container">
      <a
        class="item-wrapper"
        href="#"
        @click.prevent="goUrl({ path: '/my/coupon', name: 'coupon' })"
      >
        <w-profile-menu-item type="coupon" />
      </a>
    </li>
    <li v-if="isLogin" class="item-container">
      <a class="item-wrapper" href="https://member.wavve.com/me">
        <w-profile-menu-item type="profile" />
      </a>
    </li>
    <li v-if="isLogin" class="item-container">
      <router-link
        class="item-wrapper"
        :to="{ name: PATH_NAME_ADULT_CONTENTS }"
      >
        <w-profile-menu-item type="setup" />
      </router-link>
    </li>
    <li class="item-container">
      <a
        class="item-wrapper"
        href="#"
        @click.prevent="goUrl({ path: '/customer/user_qna', name: 'user_qna' })"
      >
        <w-profile-menu-item type="customer" />
      </a>
    </li>
    <li v-if="isLogin" class="item-container">
      <button type="button" @click.prevent="onClickLogout">
        <w-profile-menu-item type="logout" />
      </button>
    </li>
  </ul>
</template>

<script setup>
  import WProfileMenuItem from '@/components/header/profile/WProfileMenuItem'
</script>

<script>
  import {
    SHOW_ALARM_POPUP,
    UPDATE_EVENT_LAYOUT_CONTENT,
    UPDATE_MAIN_LAYOUT_CONTENT,
  } from '@/common/resources/const'
  import { PATH_NAME_ADULT_CONTENTS } from '@/common/resources/router.const'
  import constant from '@/common/resources/constant'
  import { logoutProc } from '@/common/utils/login'
  import { getAlarmsNew } from '@/common/utils/request'

  export default {
    name: 'WMyList',
    props: {
      isLogin: {
        type: Boolean,
        default: false,
      },
      voucherCount: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        alarmCount: 0,
      }
    },
    mounted() {
      this.initialize()
    },
    methods: {
      async initialize() {
        const alarmData = await getAlarmsNew()
        this.alarmCount = +alarmData?.data?.count
        if (this.alarmCount > 99) {
          this.alarmCount = '99+'
        }
      },
      onClickLogin() {
        if (this.$route.name !== 'login') {
          this.$router.replace(
            `/member/login?referer=${encodeURIComponent(this.$route.fullPath)}`,
          )
        }
      },
      onClickAlarm() {
        this.$events.$emit(SHOW_ALARM_POPUP)
      },
      goUrl(pathInfo) {
        const { path, name } = pathInfo
        if (name === this.$route.name) {
          this.$events.$emit(UPDATE_MAIN_LAYOUT_CONTENT)
          this.$events.$emit(UPDATE_EVENT_LAYOUT_CONTENT)
        } else {
          this.$router.push(path)
        }
      },
      onClickLogout() {
        logoutProc()
          .then(() => {
            window.location.href = '/index.html'
          })
          .catch(() => {
            alert(constant.MSG_COMMON_ERROR)
          })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .my-menu-list {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 24px 28px;
    .item-container {
      width: 100%;
      .item-wrapper {
        display: flex;
        align-items: center;
        width: 100%;
      }
    }
  }
</style>
